export const version = 'kunde-v1.20.0-SNAPSHOT-e948909c9ef885ad409094de7a8594e09cd5ff87';